import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const photos = [
  {
    src: "https://images.unsplash.com/photo-1707833711203-7b37bdeb73b6?auto=format&fit=crop&w=1600&q=80",
    alt: "Visakhapatnam city skyline from the sea",
    caption: "The Bay of Bengal skyline",
    span: "lg:col-span-7 lg:row-span-2",
    h: "h-[480px] lg:h-full",
  },
  {
    src: "https://images.unsplash.com/photo-1669003152631-c953ac9f3ed3?auto=format&fit=crop&w=1200&q=80",
    alt: "Aerial view of SME industrial estate near Visakhapatnam",
    caption: "SME industrial corridor",
    span: "lg:col-span-5",
    h: "h-[230px]",
  },
  {
    src: "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1200&q=80",
    alt: "Modern corporate office buildings — premium business district",
    caption: "Premium office locations",
    span: "lg:col-span-5",
    h: "h-[230px]",
  },
  {
    src: "https://images.unsplash.com/photo-1542296332-2e4473faf563?auto=format&fit=crop&w=1200&q=80",
    alt: "Modern international airport terminal — representative of Bhogapuram Airport (Alluri Sitarama Raju International Airport), Visakhapatnam's new gateway",
    caption: "Bhogapuram Airport",
    span: "lg:col-span-4",
    h: "h-[260px]",
  },
  {
    src: "https://images.unsplash.com/photo-1481437156560-3205f6a55735?auto=format&fit=crop&w=1200&q=80",
    alt: "Premium shopping mall — representative of Inorbit Mall Vizag, Visakhapatnam's newest lifestyle destination",
    caption: "Inorbit Mall · Vizag",
    span: "lg:col-span-4",
    h: "h-[260px]",
  },
  {
    src: "https://commons.wikimedia.org/wiki/Special:FilePath/Jagadamba_Junction.jpg?width=1400",
    alt: "Jagadamba Junction, the commercial heart of Visakhapatnam",
    caption: "Jagadamba Junction",
    span: "lg:col-span-4",
    h: "h-[260px]",
  },
];

export const VizagGallery = () => {
  return (
    <section id="vizag" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-brand-accent" />
              <p className="text-overline text-brand-accent">
                Visakhapatnam · Andhra Pradesh
              </p>
            </div>
            <h2 className="mt-4 font-serif text-white text-4xl md:text-5xl tracking-tight leading-tight">
              A city of <span className="italic text-brand-accent">ports, peaks &amp; possibility.</span>
            </h2>
          </div>
          <p className="md:max-w-md text-sm md:text-base text-white/60 leading-relaxed">
            Headquartered on the Bay of Bengal, Transformo operates from one of India&rsquo;s
            fastest-rising financial corridors — a port-led economy that has grown into a
            magnet for corporate India.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 lg:auto-rows-[230px] gap-4">
          {photos.map((p, i) => (
            <motion.figure
              key={p.src}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className={`group relative overflow-hidden rounded-md border border-brand-border bg-brand-surface ${p.span} ${p.h}`}
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(10,28,20,0.05) 35%, rgba(10,28,20,0.78) 100%)",
                }}
              />
              <figcaption className="absolute bottom-4 left-4 right-4">
                <p className="text-overline text-brand-accent">Vizag</p>
                <p className="mt-1 font-serif text-white text-lg md:text-xl tracking-tight leading-tight">
                  {p.caption}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <p className="mt-10 text-center text-xs uppercase tracking-[0.22em] text-white/40">
          Photography of Visakhapatnam · India&rsquo;s Eastern Naval, Port &amp; Steel City
        </p>
      </div>
    </section>
  );
};

export default VizagGallery;
